import { Flex, FlexProps, Text } from '@chakra-ui/react'
import React from 'react'
import { useBetaBadgeStyles } from '~/components/shared/componentStyles/BetaBadge.style'

export const BetaBadge = (props: FlexProps) => {
  const styles = useBetaBadgeStyles()
  return (
    <Flex sx={styles.container} {...props}>
      <Flex sx={styles.contentContainer}>
        <Text sx={styles.text}>Beta</Text>
      </Flex>
    </Flex>
  )
}
